import React from "react";
import styles from "./Schulleitung.module.css";
import schulleitungs from "./assets/q.png";

const schulleitung = [
    {
        name: "Dr. Ismail Özkan",
        class: "Schulleitung",
        email: "i.oezkan[at]iks-schule.de",
        image: require("./assets/f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg"),
    },
    {
        name: "Tayeba Khan Talaysüm",
        class: "Verwaltungsleitung & Koordinatorin",
        email: "t.khan[at]iks-schule.de",
        image: require("./assets/f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg"),
    },
    {
        name: "Volkmar Günl-Baxmeier",
        class: "IGS-Stufenleiter",
        email: "v.baxmeier[at]iks-rhein-main.com",
        image: require("./assets/f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg"),
    },
    {
        name: "Horst Breuer",
        class: "Stellv. IGS-Stufenleiter",
        email: "h.breuer[at]iks-rhein-main.com",
        image: require("./assets/f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg"),
    },
];

const SchulleitungCard = ({ schulleitung }) => (


    <div className={styles.card}>
        <img src={schulleitung.image} alt={schulleitung.name} className={styles.image} />
        <div className={styles.class}>{schulleitung.class}</div>
        <div className={styles.name}>{schulleitung.name}</div>
        <div className={styles.email}>
            <a href={`mailto:${schulleitung.email}`}>{schulleitung.email}</a>
        </div>
    </div>
);

const SchulleitungList = () => {
    return (
        <>

            <div
                className={styles.hero}
                style={{ backgroundImage: `url(${schulleitungs})` }}
            />

            <div>
        <main className="wrapper wrapperContent">
                <div className={styles.text}>
                    <h1>SCHULLEITUNG</h1>
                </div>
                 <div className={styles.container}>
                            {schulleitung.map((schulleitung, index) => (
                                <SchulleitungCard key={index} schulleitung={schulleitung} />
                            ))}
                 </div>
        </main>
    </div>
</>
    );
};

export default SchulleitungList;
